import loadingGif from "../../../assets/images/loading.gif";
import "./Loading.scss";
export const Loading = () => {
  return (
    <>
      <div className="loading-spinner-large">
        <img src={loadingGif} alt="Loading..." />
      </div>
    </>
  );
};
